import { CustomizerProductSubmitAction } from '@packages/types'
import classNames from 'classnames'
import React from 'react'

import { bulkOrderDenormalizedGroupSelector } from 'customizer/bulkOrder/selectors'
import * as customizationSelectors from 'customizer/customization/selectors'
import { stepIsAvailable } from 'customizer/customization/utils'
import { useSelector } from 'customizer/hooks'
import ProductPricing from 'customizer/pricing/components/ProductPricing'
import { customizationPriceSelector } from 'customizer/pricing/selectors'
import { showFinishCustomizationSelector } from 'customizer/questionPanel/selectors'
import * as stocksSelectors from 'customizer/stocks/selectors'
import useThemeSettings from 'customizer/theme/useThemeSettings'
import BulkOrderQuantityAndErrorMessage from 'themes/common/components/bulkOrder/BulkOrderQuantityAndErrorMessage'
import SubmitAction from 'themes/common/components/SubmitAction'
import useOutOfStockMessageCard from 'themes/common/hooks/useOutOfStockMessageCard'

import Title from '../Title'

import './MobileDisplayerTopSection.scss'

const MobileDisplayerTopSection = () => {
  const priceStyle = useThemeSettings('price')
  const actionSectionStyle = useThemeSettings('actionSection')
  const bulkOrderGroup = useSelector(bulkOrderDenormalizedGroupSelector)
  const price = useSelector(customizationPriceSelector)
  const submitAction = useSelector(customizationSelectors.submitActionSelector)
  const showFinishCustomization = useSelector(showFinishCustomizationSelector)

  const isSelectionOutOfStock = useSelector(stocksSelectors.isSelectionOutOfStockSelector)
  const { setShowOutOfStockMessageCard, setShowOutOfStockMessageCardWithTimeout, showOutOfStockMessageCard } =
    useOutOfStockMessageCard(isSelectionOutOfStock)

  return (
    <div className="mobile-displayer-top-section">
      <div
        className={classNames('mobile-displayer-top-section__wrap', {
          'mobile-displayer-top-section__wrap--no-pricing':
            !price || submitAction === CustomizerProductSubmitAction.GetAQuote,
        })}
      >
        <div className="mobile-displayer-top-section__title">
          <Title isMobile />
          <ProductPricing
            className="mobile-displayer-top-section__pricing"
            style={{
              fontFamily: priceStyle.priceFont?.fontFamily,
              fontSize: priceStyle.mobileFontSize,
              color: priceStyle.priceColor,
            }}
          />
        </div>

        {actionSectionStyle.mobileTopButtonShow && !showFinishCustomization && (
          <div className="mobile-displayer-top-section__action">
            <SubmitAction
              loading="circularCircle"
              showOutOfStockMessageCard={showOutOfStockMessageCard}
              setShowOutOfStockMessageCard={setShowOutOfStockMessageCard}
              setShowOutOfStockMessageCardWithTimeout={setShowOutOfStockMessageCardWithTimeout}
              showSummary
              style={{
                borderWidth: '1px',
                fontSize: '14px',
                borderColor: actionSectionStyle.mobileTopButtonBorderColor,
                borderRadius: actionSectionStyle.mobileTopButtonBorderRadius,
                color: actionSectionStyle.mobileTopButtonColor,
                backgroundColor: actionSectionStyle.mobileTopButtonBackgroundColor,
              }}
            />
          </div>
        )}
      </div>
      {stepIsAvailable(bulkOrderGroup) && bulkOrderGroup && (
        <BulkOrderQuantityAndErrorMessage
          bulkOrderGroup={bulkOrderGroup}
          shouldDisplayQuantityMessage
          shouldDisplayStockMessage
        />
      )}
    </div>
  )
}

export default MobileDisplayerTopSection
